module.exports = __webpack_public_path__ + "static/media/LogosCurtin.03295924.jpeg";